import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';

const DentalCriteria1 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingStore: { productLines, cart, setCurrentProductLineId },
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
    browsingCriteriaModalStore: { openBrowsingCriteriaModal },
  } = useRootStore();

  const convertedProductLines = productLines.map((line) => toJS(line)).slice();
  const convertedCart = toJS(cart);

  const bcName = 'groupSize';

  const openBcModal = (): void => {
    const selectedProductLineId = 'GroupDental';

    setCurrentProductLineId(selectedProductLineId);
    const pLine = convertedProductLines.find((line) => line.productLineId === selectedProductLineId);
    void openBrowsingCriteriaModal(
      convertedCart,
      selectedProductLineId,
      pLine?.eStoreBcFormId || pLine?.bcFormId || '',
      {
        [bcName]: '2-4',
      },
    );
  };

  // Values for radio buttons group
  const radioButtons = [
    {
      id: '2-4',
      label: '2-4 Employees',
      value: '2-4',
    },
    {
      id: '5-9',
      label: '5-9 Employees',
      value: '5-9',
    },
    {
      id: '10-24',
      label: '10-24 Employees',
      value: '10-24',
    },
    {
      id: '25-49',
      label: '25-49 Employees',
      value: '25-49',
    },
  ];

  return (
    <div>
      <TextBlock title="Select Your Group Size" subtitle="Number of employees that are expected to enroll" />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
          if (e.target.value === '2-4') {
            openBcModal();
          }
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria1, 1);
